import { useState } from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { ActiveSection, LaunchPadNavigateOptions } from "@/types/appNavigation";

type LaunchPadCaseLookupProps = {
  onNavigate: (section: ActiveSection, options?: LaunchPadNavigateOptions) => void;
};

export function LaunchPadCaseLookup({ onNavigate }: LaunchPadCaseLookupProps) {
  const [caseNumber, setCaseNumber] = useState("");

  const submit = () => {
    const trimmed = caseNumber.trim();
    if (!trimmed) return;
    onNavigate("case_portal", { caseNumber: trimmed });
    setCaseNumber("");
  };

  return (
    <Card data-testid="launch-pad-case-lookup">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold">Quick case lookup</CardTitle>
        <CardDescription>Jump straight to a permitting case in Case Portal.</CardDescription>
      </CardHeader>
      <CardContent>
        <form
          className="flex flex-col gap-2 sm:flex-row sm:items-end"
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
        >
          <div className="grid flex-1 gap-1.5">
            <Label htmlFor="launch-pad-case-number" className="sr-only">
              Case number
            </Label>
            <Input
              id="launch-pad-case-number"
              placeholder="e.g. PR-2024-00142"
              value={caseNumber}
              onChange={(e) => setCaseNumber(e.target.value)}
            />
          </div>
          <Button type="submit" variant="secondary" className="gap-2 shrink-0">
            <Search className="h-4 w-4" aria-hidden />
            Open case
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
